import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { nl2br }  from '../util';


class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { isOpen: false };
    }

    render({ summary }) {
        return (
            <show-details>
                <p>
                    {summary}&nbsp;
                    <a href='#' onClick={this.toggle}>{this.state.isOpen ? 'Show Less' : 'Learn More'}</a>
                </p>
                {this.renderDetails()}
            </show-details>
        );
    }

    renderDetails = () => {
        if (this.state.isOpen) {
            return (
                <p className='details'>
                    <button onClick={this.toggle}>✕</button>
                    <span dangerouslySetInnerHTML={{__html: nl2br(this.props.details)}} />
                </p>
            );
        }

        return null;
    }

    toggle = (e) => {
        e.preventDefault();
        this.setState({ isOpen: !this.state.isOpen });
    }
}

export default connect()(Component);
